module.exports = __webpack_public_path__ + "static/taborska-ca66a0cc72e959fb69a83c353d3fdc11.jpg";